const state = {
  blogData: {
    loading: true,
    blogusererror: "",
    bloginfo: [],
    // blogcategory:[],
  },
  blogcatedata: [],
  blogupdate: {
    loading: false,
    data: null,
    error: null,
  },
  getdata: [],
  page: 0,
  limit: 25,
  searchKey: null,
  total: 0,
  blogCategoryInfo: [],
};

export default state;
